<ng-template #modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="d-flex flex-column flex-center mb-5">
        <mat-icon class="text-primary">info_outline</mat-icon>
        <h2 class="font-weight-bolder my-5">{{modalConfig.modalTitle}}</h2>
        <ng-content></ng-content>
      </div>
      <div class="text-center">
        @if (modalConfig.hideDismissButton === undefined || !modalConfig.hideDismissButton()) {
          <button type="button" ngbAutofocus class="btn btn-secondary me-4" (click)="dismiss()"
            [disabled]="modalConfig.disableDismissButton !== undefined && modalConfig.disableDismissButton()">
            {{ modalConfig.dismissButtonLabel }}
          </button>
        }
        @if (modalConfig.hideCloseButton === undefined || !modalConfig.hideCloseButton()) {
          <button type="button" class="btn btn-primary" (click)="close()"
            [disabled]="modalConfig.disableCloseButton !== undefined && modalConfig.disableCloseButton()">
            {{ modalConfig.closeButtonLabel }}
          </button>
        }
      </div>
    </div>
  </div>
</ng-template>
